<template>
  <Modal
    width="800"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      :style="
      {
        width: '700px !important'
      }
      "
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="选择艺术家" prop="artistId">
        <c-artist-select
          class="c-form__input"
          v-model.trim="cForm.model.artistId"
           @change="
              value => {
                this.cForm.model.artistId = value;
              }
            "
        >
        </c-artist-select>
      </Form-item>

       <Form-item label="作品标题" prop="title">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.title"
          placeholder="请输入标题"
        />
      </Form-item>


      <Form-item label="作品图片" prop="image">
        <c-uploader
          class="c-form__input"
          :key="`logo-${cForm.id}`"
          :default-file-ids="cForm.model.image"
          @change="
            value => {
              handleFormUploaderChange('image', value);
            }
          "
        />
      </Form-item>

      <Form-item label="作品链接" prop="link">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.link"
          placeholder="请输入链接"
          search
          enter-button="选择链接"
          @on-search="$refs.linkSelect.show()"
        >
        </Input>
        <c-link-select
          ref="linkSelect"
          @select="
            link => {
              $set(cForm.model, 'link', link);
            }
          "
        ></c-link-select>
      </Form-item>

    
      <Form-item label="内容" prop="content">
        <c-editor
          :html="cForm.model.content"
          @change="
            html => {
              $set(cForm.model, 'content', html);
              $refs.form.validateField('content');
            }
          "
        ></c-editor>
      </Form-item>
      
      <Form-item label="状态" prop="status">
        <Select
          class="c-form__input"
          placeholder="请选择状态"
          clearable
          v-model="cForm.model.status"
        >
          <Option
            v-for="item in dicts.PublishStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
            >{{ item.label }}
          </Option>
        </Select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "arts";

@Component({
  mixins: [FormMixin]
})
export default class BrandsListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          artistId: [
            {
              required: true,
              message: "艺术家 不能为空"
            }
          ],
          title: [
            {
              required: true,
              message: "标题 不能为空"
            }
          ],
          image: [
            {
              required: true,
              message: "作品 不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
